import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import HelpOutlined from "../../Icon/HelpOutlined";
import { Help } from "../../Help";

const HelpIcon = ({
  helpModalTitle,
  help,
  closeButtonText,
  confirmButtonText,
  confirmButtonVariant,
  closeButtonVariant,
  classes,
  onClickHelpIcon,
}) => {
  const [isHelpOpened, setIsHelpOpened] = React.useState(false);
  return (
    <>
      <div
        className={classNames("mydpd-step-help")}
        onClick={() => {
          setIsHelpOpened(true);
          onClickHelpIcon();
        }}
      >
        <HelpOutlined />
      </div>

      <Help.Modal
        title={helpModalTitle}
        items={help}
        show={isHelpOpened}
        helpModalContainer={classes.helpModalContainer}
        onClose={() => setIsHelpOpened(false)}
        closeButtonText={closeButtonText}
        confirmButtonText={confirmButtonText}
        confirmButtonVariant={confirmButtonVariant}
        closeButtonVariant={closeButtonVariant}
      />
    </>
  );
};

HelpIcon.defaultProps = {
  classes: {},
  onClickHelpIcon: () => null,
  confirmButtonText: "Go Back",
  confirmButtonVariant: "dark",
};

HelpIcon.propTypes = {
  help: PropTypes.array,
  classes: PropTypes.object,
  onClickHelpIcon: PropTypes.func,
  helpModalTitle: PropTypes.string,
  closeButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  closeButtonVariant: PropTypes.string,
};

export default HelpIcon;
